<template>
  <div>
    <div v-if="displayLegend">
      <div class="flex flex-col justify-center pl-16 sm:pl-0 sm:flex-row">
        <div class="flex pl-6 mr-4 sm:pl-0">
          <div class="rounded-color bg-blue" style="margin-right: 8px"></div>
          <p>Dočasně rezervováno</p>
        </div>

        <div class="flex pt-4 pl-6 sm:pl-0 sm:pt-0">
          <div
            class="rounded-color bg-red"
            style="margin-bottom: 16px; margin-right: 8px"
          ></div>
          <p>Obsazeno</p>
        </div>
      </div>
    </div>

    <div class="pb-5 center side-padding">
      <Calendar
        locale="cs"
        :min-page="{ month: 3, year: 2025 }"
        :max-page="{ month: 10, year: 2025 }"
        :attributes="attributes"
        :rows="1"
        :columns="$screens({ default: 1, xl: 3 })"
        is-expanded
      ></Calendar>
    </div>
  </div>
</template>

<script>
import { Calendar } from "v-calendar";
import axios from "axios";

export default {
  components: {
    Calendar,
  },

  props: {
    displayLegend: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      allOb: [],
      allRez: [],
      ob_ob_days: [],
      rez_rez_days: [],
      ob_rez_days: [],
      rez_ob_days: [],
      vol_ob_days: [],
      ob_vol_days: [],
      vol_rez_days: [],
      rez_vol_days: [],
      attributes: [],
      popoverDataStridani: {
        label: "Střídání hostů",
        hideIndicator: true,
      },
      popoverDataPrijezd: {
        label: "Příjezd hostů",
        hideIndicator: true,
      },
      popoverDataOdjezd: {
        label: "Odjezd hostů",
        hideIndicator: true,
      },
    };
  },

  methods: {
    processReservations(reservations) {
      reservations.forEach((r, index, arr) => {
        let res = {
          start: new Date(r.start),
          end: new Date(r.end),
        };

        if (index === 0) {
          if (r.type === "ob") {
            this.vol_ob_days.push(res.start);
            if (arr[index + 1] && arr[index + 1].start !== r.end) {
              this.ob_vol_days.push(res.end);
            }

            this.allOb.push(res);
          } else {
            this.vol_rez_days.push(res.start);

            if (arr[index + 1] && arr[index + 1].start !== r.end) {
              this.rez_vol_days.push(res.end);
            }

            this.allRez.push(res);
          }
        } else {
          let prev = arr[index - 1];
          if (prev.end === r.start) {
            if (prev.type === "ob" && r.type === "ob") {
              this.ob_ob_days.push(res.start);
            } else if (prev.type === "ob" && r.type === "rez") {
              this.ob_rez_days.push(res.start);
            } else if (prev.type === "rez" && r.type === "ob") {
              this.rez_ob_days.push(res.start);
            } else if (prev.type === "rez" && r.type === "rez") {
              this.rez_rez_days.push(res.start);
            }

            if (r.type === "ob") {
              let indexOb = this.allOb
                .map((r) => r.end.getTime())
                .indexOf(res.start.getTime());
              if (indexOb !== -1) {
                this.allOb[indexOb].end = res.end;

                if (!arr[index + 1] || arr[index + 1].start !== r.end) {
                  this.ob_vol_days.push(res.end);
                }
              } else {
                this.allOb.push(res);

                if (!arr[index + 1] || arr[index + 1].start !== r.end) {
                  this.ob_vol_days.push(res.end);
                }
              }
            } else {
              let indexRez = this.allRez
                .map((r) => r.end.getTime())
                .indexOf(res.start.getTime());
              if (indexRez !== -1) {
                this.allRez[indexRez].end = res.end;
                if (!arr[index + 1] || arr[index + 1].start !== r.end) {
                  this.rez_vol_days.push(res.end);
                }
              } else {
                this.allRez.push(res);
                if (!arr[index + 1] || arr[index + 1].start !== r.end) {
                  this.rez_vol_days.push(res.end);
                }
              }
            }
          } else {
            if (r.type === "ob") {
              if (arr[index + 1] && arr[index + 1].start === r.end) {
              } else {
                this.ob_vol_days.push(res.end);
              }

              this.vol_ob_days.push(res.start);
              this.allOb.push(res);
            } else {
              if (arr[index + 1] && arr[index + 1].start === r.end) {
              } else {
                this.rez_vol_days.push(res.end);
              }

              this.vol_rez_days.push(res.start);
              this.allRez.push(res);
            }
          }
        }
      });
    },
  },

  mounted() {
    axios
      .get("/reservations")
      .then((res) => {
        this.processReservations(res.data.data);

        this.attributes = [
          {
            key: "obsazeno",
            highlight: {
              color: "red",
              fillMode: "light",
            },
            dates: this.allOb,
          },
          {
            key: "rezervace",
            highlight: {
              fillMode: "light",
            },

            dates: this.allRez,
          },
          {
            key: "stridani_ob_ob",
            highlight: {
              class: "stridani_ob_ob",
              contentClass: "stridani_ob_ob_color",
            },
            dates: this.ob_ob_days,
            popover: this.popoverDataStridani,
          },
          {
            key: "stridani_rez_rez",
            highlight: {
              class: "stridani_rez_rez",
              contentClass: "stridani_rez_rez_color",
            },
            dates: this.rez_rez_days,
            popover: this.popoverDataStridani,
          },
          {
            key: "stridani_rez_ob",
            highlight: {
              class: "stridani_rez_ob",
              contentClass: "stridani_rez_ob_color",
            },
            dates: this.rez_ob_days,
            popover: this.popoverDataStridani,
          },
          {
            key: "stridani_ob_rez",
            highlight: {
              class: "stridani_ob_rez",
              contentClass: "stridani_ob_rez_color",
            },
            dates: this.ob_rez_days,
            popover: this.popoverDataStridani,
          },
          {
            key: "stridani_vol_ob",
            highlight: {
              class: "stridani_vol_ob",
              contentClass: "stridani_ob_ob_color",
            },
            dates: this.vol_ob_days,
            popover: this.popoverDataPrijezd,
          },
          {
            key: "stridani_ob_vol",
            highlight: {
              class: "stridani_ob_vol",
              contentClass: "stridani_ob_ob_color",
            },
            dates: this.ob_vol_days,
            popover: this.popoverDataOdjezd,
          },
          {
            key: "stridani_rez_vol",
            highlight: {
              class: "stridani_rez_vol",
              contentClass: "stridani_rez_rez_color",
            },
            dates: this.rez_vol_days,
            popover: this.popoverDataOdjezd,
          },
          {
            key: "stridani_vol_rez",
            highlight: {
              class: "stridani_vol_rez",
              contentClass: "stridani_rez_rez_color",
            },
            dates: this.vol_rez_days,
            popover: this.popoverDataPrijezd,
          },
        ];
      })
      .catch((err) => {
        console.error("Fetching reservations failed", err);
      });
  },
};
</script>

<style>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.side-padding {
  padding-left: 48px;
  padding-right: 48px;
}

.pb-5 {
  padding-bottom: 32px;
}

.stridani_ob_ob {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_ob_ob.svg");
}

.stridani_ob_ob_color {
  color: #742a2a;
}

.stridani_rez_rez {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_rez_rez.svg");
}

.stridani_rez_rez_color {
  color: #001735;
}

.stridani_rez_ob {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_rez_ob.svg");
}

.stridani_rez_ob_color {
  color: #222222;
}

.stridani_ob_rez {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_ob_rez.svg");
}

.stridani_ob_vol {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_ob_vol.svg");
}

.stridani_vol_ob {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_vol_ob.svg");
}

.stridani_rez_vol {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_rez_vol.svg");
}

.stridani_vol_rez {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_vol_rez.svg");
}

.stridani_ob_rez_color {
  color: #252525;
}

.rounded-color {
  height: 25px;
  width: 25px;

  border-radius: 50%;
  display: inline-block;
}

.bg-blue {
  background-color: #bee3f8;
}

.bg-red {
  background-color: #fed7d7;
}
</style>

